// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dx5jl","colBig":"styles_colBig__Uh_lL","colSmall":"styles_colSmall__199Rr"};